// extracted by mini-css-extract-plugin
module.exports = {"mobile":"index_mobile__gauT_","prefix":"index_prefix__7Fjm4","btn":"index_btn__WimiX","val":"index_val__5HhZD","formType":"index_formType__gzZmz"};